import Card from 'client/common/components/card';

import './index.css';

export default Card;
